import * as Factory from 'factory.ts'
import faker from 'faker'

import { InboxMessageMock } from './inboxMessage.factory'
import { UserMock } from './user.factory'
import { type Inbox } from '../../models'

export const InboxMock = Factory.Sync.makeFactory<Inbox>({
  id: Factory.each(() => faker.random.number()),
  receiver: Factory.each(() => UserMock.build()),
  created_at: faker.date.past(10).toISOString(),
  is_archived: false,
  is_read: false,
  is_starred: false,
  message: Factory.each(() => InboxMessageMock.build()),
  metadata: {},
  updated_at: Factory.each(() => faker.date.past(0.1).toISOString()),
  url: faker.internet.url(),
})
